import { useState,useContext} from 'react';
import "./LoginPage.css";
import { Formik } from 'formik';
import axios from 'axios';
import { site_url } from "./../config.js";
import {  Link } from "react-router-dom";
import { AuthContext } from '../AuthContext';
import { Navigate, useNavigate } from 'react-router-dom';

function Index({ children }) {

  const [msg, setMsg] = useState([]);
  const { user, login,setUser } = useContext(AuthContext);
  const navigate = useNavigate();


  if (user) {
    return <Navigate to="/home" />;
  }

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    
    try {
      
      const response = await axios.post(site_url+'/login', values);
   
      if(response.data.status == 'success'){

        
         localStorage.setItem('access_token',JSON.stringify(response.data.access_token)); 
       
         setUser(response.data.access_token);
    
        // navigate('/home');
        // resetForm();
        setMsg(response.data)
      }else if(response.data.status == 'failed'){
        setMsg(response.data)
      }
       // Reset form after success
    } catch (error) {
      console.error(error);
    } finally {
      setSubmitting(false); // Stop loading spinner
    }
  };


  return (
    <div className="login-container">
      <div className="login-header">
        <img
          src="https://static.vecteezy.com/system/resources/previews/001/082/517/non_2x/digital-marketing-concept-store-front-vector.jpg" // Replace with your truck image URL
          alt="Truck"
          className="header-image"
        />
      </div>
      <div className="login-form">
      <Formik
       initialValues={{ phone: '', password: '' }}
       validate={values => {
         const errors = {};
         if (!values.phone) {
           errors.phone = 'Phone Number is required';
         }else if (!/^\d{10}$/.test(values.phone)) {
            errors.phone = 'Phone number must be exactly 10 digits';
          }
         if (!values.password) {
            errors.password = 'Password is required';
          }
         
         return errors;
       }}
       onSubmit={handleSubmit}
     >
       {({
         values,
         errors,
         touched,
         handleChange,
         handleBlur,
         handleSubmit,
         isSubmitting,
         /* and other goodies */
       }) => (
      <form onSubmit={handleSubmit}>
        <h2>Login</h2>
        {msg.status == 'failed' && (
        <div class="alert alert-danger mb-1" role="alert">
      Invalid login credentials
        </div>
        )}
        <div className="form-group">
          <label htmlFor="email">
            <i className="fa fa-phone"></i>
          </label>
          <input type="number" name="phone"  onChange={handleChange} onBlur={handleBlur} value={values.phone} id="email" placeholder="Enter Your Mobile Number" />
        </div>
        {errors.phone && touched.phone &&(<span className="error">{ errors.phone}</span>)}


        <br />
        <div className="form-group">
          <label htmlFor="password">
            <i className="fa fa-lock"></i>
          </label>
          <input type="password"  name="password" onChange={handleChange} onBlur={handleBlur} value={values.password} id="password" placeholder="M-Pin or Password " />
          <i className="fa fa-eye toggle-password"></i>
        </div>
        {errors.password && touched.password &&(<span className="error">{ errors.password}</span>)}

       
        <button  type="submit" disabled={isSubmitting} className="login-button">{isSubmitting ? 'Submitting...' : 'Login'}</button>
        <p className="register-text">
        </p>
        
        </form>
       )}
       </Formik>
      </div>
    </div>
  );
}

export default Index;
